import { createFileRoute } from "@tanstack/react-router";
import { PermissionGate } from "@/shared/auth/PermissionGate";
import { PERMISOS } from "@/lib/permisos";
import { ErrorAlert } from "@/components/ui";
import { AdminAreasPage } from "@/features/admin-areas/components/AdminAreasPage";
import { areasAdminPageQueryOptions } from "@/features/admin-areas/hooks/use-areas-admin";

/** Ruta `/admin/areas` · CRUD de áreas. */
export const Route = createFileRoute("/_authed-tw/admin/areas")({
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureQueryData(areasAdminPageQueryOptions({ page: 1, pageSize: 15 })),
  component: () => (
    <PermissionGate permisos={[PERMISOS.adminAreas]}>
      <AdminAreasPage />
    </PermissionGate>
  ),
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
